import React from 'react';
export function LogoTicker() {
  // You can replace these with your actual partner/technology logos
  const topRowLogos = [{
    name: 'Commerce7',
    src: 'https://assets.modern-commerce.io/commerce7-dark-logo.svg'
  }, {
    name: 'Shopify',
    src: 'https://assets.modern-commerce.io/Shopify%20Logo_Monotone_Black_PNG.PNG'
  }, {
    name: 'Klaviyo',
    src: 'https://assets.modern-commerce.io/id-7qp5KY6_1758602521899.jpeg'
  }, {
    name: 'Stripe',
    src: 'https://cdn.worldvectorlogo.com/logos/stripe-4.svg'
  }, {
    name: 'Google Analytics',
    src: 'https://cdn.worldvectorlogo.com/logos/google-analytics-4.svg'
  }, {
    name: 'Mailchimp',
    src: 'https://cdn.worldvectorlogo.com/logos/mailchimp-freddie-icon.svg'
  }, {
    name: 'Recharge',
    src: 'https://assets.modern-commerce.io/idRLJ6mwWt_logos.jpeg'
  }, {
    name: 'Gorgias',
    src: 'https://assets.modern-commerce.io/Gorgias_idFQJUcJ4d_0.svg'
  }, {
    name: 'Skio',
    src: 'https://assets.modern-commerce.io/idmhBqQ2QP_logos.png'
  }, {
    name: 'Lightspeed',
    src: 'https://assets.modern-commerce.io/LightspeedFlame_Red.svg'
  }, {
    name: 'Wine Hub',
    src: 'https://assets.modern-commerce.io/Winehub-LOGO.webp'
  }];
  const LogoRow = ({
    logos,
    direction
  }) => <div className="relative mb-8 last:mb-0" data-id="element-145">
      <div className={`flex ${direction === 'left' ? 'animate-scroll-left' : 'animate-scroll-right'}`} data-id="element-146">
        {/* First set of logos */}
        <div className="flex gap-16 pr-16" data-id="element-147">
          {logos.map((logo, index) => <div key={`${logo.name}-1-${index}`} className="flex items-center justify-center w-[180px] h-[80px] opacity-60 hover:opacity-100 transition-opacity" data-id="element-148">
              <img src={logo.src} alt={logo.name} className="h-10 object-contain" data-id="element-149" />
            </div>)}
        </div>
        {/* Duplicate set for seamless loop */}
        <div className="flex gap-16 pr-16" data-id="element-150">
          {logos.map((logo, index) => <div key={`${logo.name}-2-${index}`} className="flex items-center justify-center w-[180px] h-[80px] opacity-60 hover:opacity-100 transition-opacity" data-id="element-151">
              <img src={logo.src} alt={logo.name} className="h-10 object-contain" data-id="element-152" />
            </div>)}
        </div>
      </div>
    </div>;
  return <section className="bg-white overflow-hidden pb-20" data-id="element-153">
      <div className="max-w-[1400px] mx-auto px-6 mb-12 text-center" data-id="element-154"></div>
      <LogoRow logos={topRowLogos} direction="left" data-id="element-155" />
      <style jsx data-id="element-156">{`
        @keyframes scrollLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        @keyframes scrollRight {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
        .animate-scroll-left {
          animation: scrollLeft 30s linear infinite;
        }
        .animate-scroll-right {
          animation: scrollRight 30s linear infinite;
        }
        .animate-scroll-left:hover,
        .animate-scroll-right:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}